import { render, staticRenderFns } from "./TenderMenu.vue?vue&type=template&id=d34bd076"
import script from "./TenderMenu.vue?vue&type=script&lang=js"
export * from "./TenderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports